import { useEffect, useState } from 'react';
import { getDashboardDesignValues } from '../../services/user.service';

export default function HeaderPartner() {
  const [designValues, setDesignValues] = useState<any>(null);

  useEffect(() => {
    (async () => {
      try {
        const values = await getDashboardDesignValues();
        // eslint-disable-next-line no-console
        console.log('Dashboard design values:', values);
        setDesignValues(values);
      } catch (e) {
        console.error('Failed to fetch dashboard design values', e);
      }
    })();
  }, []);

  return (
    <>
      <header className={`bg-holos-light sticky top-0 z-50 shadow-md`}>
        <div className={`flex items-center h-20 px-4 md:px-6 transition-opacity duration-300 opacity-100`}>
          <h1 className="flex-grow md:flex-grow-0 flex items-center">
            {designValues?.studioImage && (
              <img
                src={`https://image.beholos.com/${designValues.studioImage}`}
                alt="Corporate Logo"
                className="hidden md:inline-flex mr-3 h-9 w-auto"
              />
            )}
            <a href="/partner" className="flex items-center h-full">
              <img
                src="https://cache.beholos.com/img/holos/logos/holos-logo-final-version-v2.svg"
                alt="Holos Logo"
                className="hidden md:block h-8 w-auto"
              />
              <img
                src="https://cache.beholos.com/img/holos/logos/logo-black-short.svg"
                alt="Holos Logo"
                className="md:hidden h-8 w-auto"
              />
            </a>
          </h1>
        </div>
      </header>
    </>
  );
}